import { GameConceptSellerDetails } from "../models/gameConceptSellerDetails";

export const getGameConceptSellerEligibility = (
  sellerDetails: GameConceptSellerDetails | null
) => ({
  isActiveSeller: !!sellerDetails?.sellerId && sellerDetails.sellerStatus === "ACTIVE",
  hasPassedVetting: !!sellerDetails?.sellerId && sellerDetails.vettingStatus === "Authorized",
});
